// extracted by mini-css-extract-plugin
export default {"wrapper":"Users_wrapper__CJUyG","avatar":"Users_avatar__i1N-L","text":"Users_text__gy57x"};